import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import axios from "axios";
import {  GridItem  } from '@chakra-ui/react';
 
import SingleKidsCard from '../Components/SingleKidsCard';
 

const   KidsWearDetails  = () => {
  const [data, setData] = useState({});
  let {id}=useParams();
  console.log(id);
    const getData= async (id)=>{
        return axios({
            method : "get" ,
            url : `https://mock-api-server-2399.onrender.com/kids/${id}`
        }).then((res)=> {
            console.log(res.data)
            setData(res.data)
        });
    }

    useEffect(() => {
      getData(id);
    }, [id])
    


  return (
            <GridItem>
                 <SingleKidsCard  
                  key={data.id}
                  {...data}
                 />
            </GridItem>
 
  )
}

export default  KidsWearDetails 


 